import React, { Component } from 'react';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Http } from '../../../../../support';
import LoadingButton from '../../../../../facturotopia/LoadingButton';

class ComprobanteDownloadActions extends Component {

  state = {
    busy: false
  }

  download = async (kind) => {
    const { data } = this.props;

    this.setState({
      busy: true
    });

    try {
      const params = {
        type: kind || 'pdf',
      }

      const response = await Http.get(`${window.BONJOUR_URL}/ext/receptores/facturas/${data.uuid}/download`, { params, responseType: 'blob' });

      window.downloadFromHttpResponse(response);
    } catch (error) {
      window.ToastManager.show({
        variant: 'error',
        title: 'Error',
        message: error.data?.message || error.message || 'No podemos descargar tu comprobante'
      });
    } finally {
      this.setState({
        busy: false
      });
    }
  }

  render() {
    const { busy: downloading } = this.props;

    if (downloading) {
      return (
        <LoadingButton type="button"
          variant="transparent"
          loading={ downloading }
        >
          Descargando
        </LoadingButton>
      )
    }

    return (
      <Dropdown alignRight={ true }>
        <Dropdown.Toggle variant="secondary" id="dropdown-basic">
          Descargar { ' ' }
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <Dropdown.Item as="div" onClick={ this.download.bind(this, 'zip') }>
            Zip
            <span className="float-right text-muted">
              <FontAwesomeIcon icon={ ['far', 'file-archive'] } />
            </span>
          </Dropdown.Item>
          <Dropdown.Item as="div" onClick={ this.download.bind(this, 'pdf') }>
            Pdf
            <span className="float-right text-muted">
              <FontAwesomeIcon icon={ ['far', 'file-pdf'] } />
            </span>
          </Dropdown.Item>
          <Dropdown.Item as="div" onClick={ this.download.bind(this, 'xml') }>
            Xml
            <span className="float-right text-muted">
              <FontAwesomeIcon icon={ ['far', 'file-code'] } />
            </span>
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    )
  }
}

export default ComprobanteDownloadActions;